import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
function is_selected(item, selection) {
        item = ko.unwrap(item);
        selection = ko.unwrap(selection);
        if (selection) {
            return selection.is_selected(item);
        }
        return false;
}
function can_deselect(item, selection) {
    item = ko.unwrap(item);
    selection = ko.unwrap(selection);
    if(selection)
        return !selection.all_selected();
    return false;
}
ko.bindingHandlers.selectioncheck = {
    init: function(elt, va, allbindings, model, context) {
        $(elt).on("click tap", function(ev,ui) {
            var selection = ko.unwrap(allbindings().selection);
            var self = ko.unwrap(va());
            if (is_selected(self, selection))
            {
                selection.remove(self);
            } else {
                selection.push(self);
            }
        });
    },
    update: function(elt, va, allbindings, model, context) {
        if (is_selected(va(), allbindings().selection)) {
            $(elt).removeClass("fa-square-o").addClass("fa-check-square-o");
            if (!can_deselect(va(), allbindings().selection)) {
                $(elt).css("opacity", "0.5");
            } else {
                $(elt).css("opacity", "1");
            }
        } else {
            $(elt).removeClass("fa-check-square-o").addClass("fa-square-o");
            $(elt).css("opacity", "1");
        }
    }
};
